/**
 * Custom Font Loader
 * This script handles the loading of custom fonts via URLs in the theme editor
 */
document.addEventListener('DOMContentLoaded', function() {
  console.log('Custom Font Loader initialized');
  
  // Check if the customFontSettings exist
  if (!window.theme || !window.theme.customFontSettings) {
    console.error('Theme settings not found');
    return;
  }
  
  const customFontSettings = window.theme.customFontSettings;
  console.log('Font Settings:', customFontSettings);
  
  // Check if custom fonts are enabled - compare as boolean rather than string
  const customFontEnabled = customFontSettings.enable_custom_font_library === true;
  console.log('Custom Fonts Enabled:', customFontEnabled);
  
  if (!customFontEnabled) {
    console.log('Custom fonts are disabled in theme settings');
    return;
  }

  // Function to create @font-face CSS
  function createFontFace(fontName, fontUrl, fontWeight, fontStyle) {
    if (!fontUrl) return '';
    
    console.log(`Creating @font-face for ${fontName} (${fontWeight}, ${fontStyle}) with URL: ${fontUrl}`);
    
    return `
      @font-face {
        font-family: '${fontName}';
        src: url('${fontUrl}') format('woff2');
        font-weight: ${fontWeight};
        font-style: ${fontStyle};
        font-display: swap;
      }
    `;
  }

  // Generate CSS for custom fonts
  let customFontCSS = '';
  
  // Primary Custom Font
  if (customFontSettings.custom_font_1_name) {
    const fontName = customFontSettings.custom_font_1_name;
    console.log('Configuring Primary Font:', fontName);
    
    // Regular
    if (customFontSettings.custom_font_1_regular) {
      customFontCSS += createFontFace(
        fontName, 
        customFontSettings.custom_font_1_regular,
        'normal',
        'normal'
      );
    }
    
    // Bold
    if (customFontSettings.custom_font_1_bold) {
      customFontCSS += createFontFace(
        fontName, 
        customFontSettings.custom_font_1_bold,
        'bold',
        'normal'
      );
    }
    
    // Italic
    if (customFontSettings.custom_font_1_italic) {
      customFontCSS += createFontFace(
        fontName, 
        customFontSettings.custom_font_1_italic,
        'normal',
        'italic'
      );
    }
    
    // Bold Italic
    if (customFontSettings.custom_font_1_bold_italic) {
      customFontCSS += createFontFace(
        fontName, 
        customFontSettings.custom_font_1_bold_italic,
        'bold',
        'italic'
      );
    }
  }
  
  // Secondary Custom Font
  if (customFontSettings.custom_font_2_name) {
    const fontName = customFontSettings.custom_font_2_name;
    console.log('Configuring Secondary Font:', fontName);
    
    // Regular
    if (customFontSettings.custom_font_2_regular) {
      customFontCSS += createFontFace(
        fontName, 
        customFontSettings.custom_font_2_regular,
        'normal',
        'normal'
      );
    }
    
    // Bold
    if (customFontSettings.custom_font_2_bold) {
      customFontCSS += createFontFace(
        fontName, 
        customFontSettings.custom_font_2_bold,
        'bold',
        'normal'
      );
    }
    
    // Italic
    if (customFontSettings.custom_font_2_italic) {
      customFontCSS += createFontFace(
        fontName, 
        customFontSettings.custom_font_2_italic,
        'normal',
        'italic'
      );
    }
    
    // Bold Italic
    if (customFontSettings.custom_font_2_bold_italic) {
      customFontCSS += createFontFace(
        fontName, 
        customFontSettings.custom_font_2_bold_italic,
        'bold',
        'italic'
      );
    }
  }
  
  // Apply font family CSS based on selections
  if (customFontSettings.heading_custom_font && customFontSettings.heading_custom_font !== 'none') {
    const fontKey = customFontSettings.heading_custom_font;
    const fontNameSetting = fontKey === 'custom_font_1' ? 'custom_font_1_name' : 'custom_font_2_name';
    const fontName = customFontSettings[fontNameSetting];
    
    if (fontName) {
      console.log(`Applying ${fontName} to headings`);
      customFontCSS += `
        h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
          font-family: '${fontName}', sans-serif !important;
        }
      `;
    }
  }
  
  if (customFontSettings.body_custom_font && customFontSettings.body_custom_font !== 'none') {
    const fontKey = customFontSettings.body_custom_font;
    const fontNameSetting = fontKey === 'custom_font_1' ? 'custom_font_1_name' : 'custom_font_2_name';
    const fontName = customFontSettings[fontNameSetting];
    
    if (fontName) {
      console.log(`Applying ${fontName} to body text`);
      customFontCSS += `
        body, p, span, div, button, input, select, textarea {
          font-family: '${fontName}', sans-serif !important;
        }
      `;
    }
  }
  
  // Inject the custom font CSS into the page
  if (customFontCSS) {
    console.log('Injecting custom font CSS');
    console.log(customFontCSS);
    const styleTag = document.createElement('style');
    styleTag.id = 'custom-font-styles';
    styleTag.textContent = customFontCSS;
    document.head.appendChild(styleTag);
    console.log('Custom font CSS successfully injected');
  } else {
    console.log('No custom font CSS to inject');
  }
}); 